import React, { useState } from "react";
import { Image } from "react-bootstrap";
import { IPetImageHeaderProps } from "./PetImageHeader.types";
import { useFlowData } from "@adaptis/flow-components";
import { PetType } from "../../util/common-types";

import "./PetImageHeader.scss";

export default function PetImageHeader(props: IPetImageHeaderProps) {
  const { getData, setData } = useFlowData();
  const petType = getData("petType");

  return (
    <div
      data-testid="PetImageHeader"
      className={
           props.className != null &&
        props.className != undefined
          ? props.className + " flc_pet-image-header "
          : ""
      }
    >
      {(petType as PetType) == PetType.Dog && <Image src={props.imageUrlDog} />}
      {(petType as PetType) == PetType.Cat && <Image src={props.imageUrlCat} />}
    </div>
  );
}
